import { FC, ReactNode, memo } from 'react';
import styled from 'styled-components';
import { ReactComponent as BrandSvg } from './brand.svg';

const StyledBrand = styled(BrandSvg)`
  max-width: 14rem;
`;

export interface BrandProps {
  children?: ReactNode;
}

export const Brand: FC<BrandProps> = ({ children }) => {
  return <StyledBrand />;
};

export const BrandMemo = memo(Brand);
